"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.number.constructor");
var _thousandsConvert = require("@/utils/thousandsConvert");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 金额千分位
var _default = exports.default = {
  props: {
    value: {
      type: [String, Number],
      default: null,
      desc: "数值"
    },
    disabled: {
      type: Boolean,
      default: false,
      desc: "是否禁止"
    },
    toFixed: {
      type: Number,
      default: 2
    },
    //是否要默认值为0
    isZero: {
      type: Boolean,
      default: false
    },
    showAllFlag: {
      type: Boolean,
      default: true,
      desc: '是否展示全部,不省略小数0'
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      focused: false,
      regex: new RegExp("^([0-9-]\\d*\\.?\\d{0,".concat(this.toFixed, "})?.*$"))
    };
  },
  computed: {
    formatValue: function formatValue() {
      if (this.focused) {
        return this.value ? this.value.toString().replace(",", "") : "";
      } else {
        if (this.value === 0) {
          return (0, _thousandsConvert.thousandsConvert)(this.value, this.toFixed, this.showAllFlag);
        } else if (this.value === "" || this.value === null || this.value === undefined) {
          var value = (0, _thousandsConvert.thousandsConvert)(0, this.toFixed, this.showAllFlag);
          if (this.isZero) {
            this.$emit("input", value);
            return value;
          }
          return null;
        } else {
          // this.value = thousandsConvert(this.value, this.toFixed);
          // return this.value;
          return (0, _thousandsConvert.thousandsConvert)(this.value, this.toFixed, this.showAllFlag);
        }
      }
    }
  },
  watch: {
    value: function value(val) {
      if (this.validateEvent) {
        this.dispatch("ElFormItem", "el.form.change", [val]);
      }
    }
  },
  methods: {
    updatevalue: function updatevalue(value) {
      var formatvalue = value ? value.toString().replace(this.regex, '$1').replace(/[^0-9.-]/g, "").replace(",", "") : "";
      if (!Number(formatvalue)) {
        this.$emit('input', 0);
      } else {
        if (this.min !== null && Number(formatvalue) < this.min) {
          this.$emit('input', this.min.toFixed(this.toFixed));
        } else if (this.max !== null && Number(formatvalue) > this.max) {
          this.$emit('input', this.max.toFixed(this.toFixed));
        } else {
          this.$emit('input', formatvalue);
        }
      }
    },
    onBlur: function onBlur() {
      this.focused = false;
      this.$emit("blur");
      this.dispatch("ElFormItem", "el.form.blur", [this.value]);
    },
    selectAll: function selectAll(event) {
      this.focused = true;
      setTimeout(function () {
        event.target.select();
      }, 0);
    },
    onChange: function onChange(val) {
      this.$emit("change", val);
    },
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    }
  }
};